import { TextField, type SxProps, type TextFieldProps, type Theme } from '@mui/material';
import { color } from '@/colors';

type TextAreaSx = Exclude<SxProps<Theme>, readonly unknown[] | ((theme: Theme) => unknown)>;

const defaultSx: TextAreaSx = {
  mt: 1,
  borderColor: color.White16_T,
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: color.White40_T,
    },
    '&.Mui-focused fieldset': {
      borderColor: color.White40_T,
      borderWidth: 1,
    },
    '&.Mui-disabled fieldset': {
      borderColor: color.White08_T,
    },
  },
  '& .MuiInputBase-input.Mui-disabled': {
    color: color.White08_T,
    WebkitTextFillColor: color.White08_T,
  },
};

const DEFAULT_ROWS = 8;

export type TextAreaProps = Omit<TextFieldProps, 'multiline'>;

export const TextArea = ({
  fullWidth = true,
  size = 'small',
  rows = DEFAULT_ROWS,
  slotProps,
  sx,
  inputProps,
  ...props
}: TextAreaProps) => {
  const mergedInputProps = {
    ...inputProps,
    style: { resize: 'vertical' as const, ...inputProps?.style },
  };

  return (
    <TextField
      multiline
      fullWidth={fullWidth}
      size={size}
      rows={props.minRows === undefined && props.maxRows === undefined ? rows : undefined}
      slotProps={slotProps}
      inputProps={mergedInputProps}
      sx={{ ...defaultSx, ...sx }}
      {...props}
    />
  );
};
